export default [
  {
    title: 'spirit',
    description:
      'Learning how to elevate your consciousness and connect with something ‘greater’ than yourself gives you a sense of meaning and improves your quality of life. Spiritual practices equate to better health and overall wellbeing.',
    cdnId: 'app_images/spirit-prayer'
  },
  {
    title: 'mindset',
    description:
      'Growth is the belief that you are capable of working to increase your potential and intelligence. Your commitment to developing a growth mindset will help you to take control of your life.',
    cdnId: 'app_images/mindset-rocks'
  },
  {
    title: 'nutrition',
    description:
      'Nutrition is the key component to your fitness. It is difficult to train your way out of poor nutrition. Following a balanced diet is essential to your success.',
    cdnId: 'app_images/nutrition-bowl'
  },
  {
    title: 'exercise',
    description:
      'Exercise principle consists of 4 core modules: mobility & flexibility, balance & coordination, core & conditioning, and functional resistance strength training. Committing to this model will help improve circulation, range of motion, alleviate daily aches & pains, sharpen awareness, while increasing strength and conditioning..',
    cdnId: 'app_images/exercise-db-row'
  }
];
